<section class="blog-hero-section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <span class="hero-badge">Latest Insights</span>
                    <h1 class="hero-title">Blog & Insights</h1>
                    <p class="hero-description">Stay updated with the latest trends, best practices, and expert insights in cloud computing, cybersecurity, and digital transformation. Explore our comprehensive resources to enhance your knowledge.</p>
                    
                    <div class="hero-actions">
                        <a class="btn-primary-gradient me-3" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            Contact Support
                        </a>
                        <a class="btn-outline-light" routerLink="/services">
                            <i class="bx bx-server"></i>
                            View Services
                        </a>
                    </div>
                    
                    <div class="hero-features">
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Industry Insights</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Best Practices</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Case Studies</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-image">
                    <div class="image-decoration">
                        <div class="floating-card card-1">
                            <i class="bx bx-news"></i>
                            <span>Latest News</span>
                        </div>
                        <div class="floating-card card-2">
                            <i class="bx bx-trending-up"></i>
                            <span>Trending Topics</span>
                        </div>
                        <div class="floating-card card-3">
                            <i class="bx bx-book-bookmark"></i>
                            <span>Guides & Tutorials</span>
                        </div>
                    </div>
                    <img src="assets/img/banner-one/banner-one-main-img.png" alt="Blog & Insights" class="img-fluid main-image">
                </div>
            </div>
        </div>
    </div>
    <div class="hero-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
    </div>
</section>

<section class="blog-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Knowledge Hub</span>
            <h2>Blog Categories</h2>
            <p>Explore our comprehensive blog posts organized by category to find exactly what you need.</p>
        </div>

        <div class="blog-categories">
            <div class="category-card">
                <div class="category-header">
                    <div class="category-icon">
                        <i class="bx bx-cloud"></i>
                    </div>
                </div>
                <h3>Cloud Computing</h3>
                <p>Latest trends, innovations, and best practices in cloud infrastructure and services.</p>
                <a class="category-link" routerLink="/cloud-infrastructure">
                    Explore Articles <i class="bx bx-chevron-right"></i>
                </a>
            </div>

            <div class="category-card">
                <div class="category-header">
                    <div class="category-icon">
                        <i class="bx bx-shield-quarter"></i>
                    </div>
                </div>
                <h3>Cybersecurity</h3>
                <p>Essential security measures, compliance standards, and threat prevention strategies.</p>
                <a class="category-link" routerLink="/cybersecurity">
                    Security Insights <i class="bx bx-chevron-right"></i>
                </a>
            </div>

            <div class="category-card">
                <div class="category-header">
                    <div class="category-icon">
                        <i class="bx bx-code-curly"></i>
                    </div>
                </div>
                <h3>Development</h3>
                <p>Programming tips, DevOps practices, and software development methodologies.</p>
                <a class="category-link" routerLink="/documentation">
                    Development Guides <i class="bx bx-chevron-right"></i>
                </a>
            </div>

            <div class="category-card">
                <div class="category-header">
                    <div class="category-icon">
                        <i class="bx bx-bar-chart-alt-2"></i>
                    </div>
                </div>
                <h3>Performance</h3>
                <p>Optimization techniques for better performance and cost efficiency.</p>
                <a class="category-link" routerLink="/documentation/optimization">
                    Optimization Tips <i class="bx bx-chevron-right"></i>
                </a>
            </div>

            <div class="category-card">
                <div class="category-header">
                    <div class="category-icon">
                        <i class="bx bx-cog"></i>
                    </div>
                </div>
                <h3>Infrastructure</h3>
                <p>Management and monitoring tools for your cloud infrastructure.</p>
                <a class="category-link" routerLink="/documentation/management">
                    Management Docs <i class="bx bx-chevron-right"></i>
                </a>
            </div>

            <div class="category-card">
                <div class="category-header">
                    <div class="category-icon">
                        <i class="bx bx-user-check"></i>
                    </div>
                </div>
                <h3>Case Studies</h3>
                <p>Real-world success stories and implementation examples.</p>
                <a class="category-link" routerLink="/case-studies">
                    View Cases <i class="bx bx-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>
</section>

<section class="search-section">
    <div class="container">
        <div class="search-content">
            <h2>Can't Find What You're Looking For?</h2>
            <p>Search our entire blog knowledge base for specific topics, guides, or solutions.</p>
            <form class="search-form">
                <input type="text" class="search-input" placeholder="Search blog posts...">
                <button type="submit" class="search-button">
                    <i class="bx bx-search"></i> Search
                </button>
            </form>
        </div>
    </div>
</section>

<section class="blog-section ptb-100">
    <div class="container">
        <div class="popular-articles">
            <div class="section-title text-center">
                <span class="section-badge">Popular Articles</span>
                <h2>Most Viewed Blog Posts</h2>
                <p>Check out our most frequently accessed articles and tutorials</p>
            </div>

            <div class="articles-grid">
                <div class="article-card">
                    <h4>Web domain hosting the best service work</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <div class="article-meta">
                        <div class="article-tags">
                            <span class="tag">Cloud Hosting</span>
                            <span class="tag">Best Practices</span>
                        </div>
                        <span>5 min read</span>
                    </div>
                </div>

                <div class="article-card">
                    <h4>Web development hosting the best service work</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <div class="article-meta">
                        <div class="article-tags">
                            <span class="tag">Development</span>
                            <span class="tag">Hosting</span>
                        </div>
                        <span>7 min read</span>
                    </div>
                </div>

                <div class="article-card">
                    <h4>Web hosting the best service work future</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <div class="article-meta">
                        <div class="article-tags">
                            <span class="tag">Future Tech</span>
                            <span class="tag">Infrastructure</span>
                        </div>
                        <span>6 min read</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="blog-contact-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="contact-content">
                    <div class="section-title">
                        <span class="section-badge">Need More Insights?</span>
                        <h2>Want to Stay Updated?</h2>
                        <p>Subscribe to our newsletter to receive the latest blog posts, industry insights, and exclusive content directly in your inbox.</p>
                    </div>
                    
                    <div class="contact-features">
                        <div class="contact-feature-item">
                            <i class="bx bx-envelope"></i>
                            <div class="contact-feature-content">
                                <h5>Newsletter Subscription</h5>
                                <p>Weekly insights delivered</p>
                            </div>
                        </div>
                        <div class="contact-feature-item">
                            <i class="bx bx-chat"></i>
                            <div class="contact-feature-content">
                                <h5>Community Forum</h5>
                                <p>Join discussions with experts</p>
                            </div>
                        </div>
                        <div class="contact-feature-item">
                            <i class="bx bx-phone"></i>
                            <div class="contact-feature-content">
                                <h5>Direct Contact</h5>
                                <p>blogs@insightfulitservices.com</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="contact-actions">
                        <a class="btn-primary-gradient me-3" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            Contact Our Team
                        </a>
                        <a class="btn-outline-light" routerLink="/sign-up">
                            <i class="bx bx-user-plus"></i>
                            Subscribe Now
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="contact-image">
                    <img src="assets/img/choose-img.png" alt="Blog Subscription" class="img-fluid">
                    <div class="floating-elements">
                        <div class="floating-badge badge-1">
                            <i class="bx bx-news"></i>
                            <span>Weekly Updates</span>
                        </div>
                        <div class="floating-badge badge-2">
                            <i class="bx bx-time"></i>
                            <span>&lt; 5 min Read</span>
                        </div>
                        <div class="floating-badge badge-3">
                            <i class="bx bx-check-circle"></i>
                            <span>Expert Insights</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="contact-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
    </div>
</section>